<template>
    <div>
        <b-card
            v-if="view === 'edit'"
            class="mb-5"
        >
            <p class="mb-1">
                Document title
            </p>
            <b-form-input
                v-model="title"
                @input="saveDocument"
            />
        </b-card>

        <draggable
            v-model="sortedSections"
            :class="dragging ? 'dragging' : ''"
            @start="dragging = true"
            @end="dragging = false"
        >
            <div
                v-for="section in document.sections"
                :key="`section-${section.id}`"
            >
                <AddSectionButton
                    v-if="view === 'edit'"
                    :before="section.id"
                />
                <Section
                    :section="section"
                />
            </div>
        </draggable>

        <div
            v-if="canEdit"
            class="footer fixed"
        >
            <div class="d-flex align-items-center">
                <b-button
                    v-for="(viewMode, index) in viewOptions"
                    :key="index"
                    :variant="view === viewMode.value ? 'primary' : 'outline-primary'"
                    class="mx-2"
                    @click="view = viewMode.value"
                >
                    <i :class="viewMode.icon" />
                    {{ viewMode.text }}
                </b-button>
            </div>

        </div>

        <AddSectionButton v-if="view === 'edit'" />
        <SectionModal />
        <SectionDeleteModal />
        <FieldModal />
        <FieldDeleteModal />
    </div>
</template>

<script>
import draggable from 'vuedraggable';
import { dispatch, sync } from 'vuex-pathify';
import { debounce } from 'throttle-debounce';
import store from './_store';
import Section from '@/modules/document/_component/Section.vue';
import SectionModal from '@/modules/document/_component/SectionModal.vue';
import FieldModal from '@/modules/document/_component/FieldModal.vue';
import FieldDeleteModal from '@/modules/document/_component/FieldDeleteModal.vue';
import SectionDeleteModal from '@/modules/document/_component/SectionDeleteModal.vue';
import AddSectionButton from '@/modules/document/_component/AddSectionButton.vue';

export default {
    components: {
        AddSectionButton,
        draggable,
        SectionModal,
        SectionDeleteModal,
        FieldModal,
        FieldDeleteModal,
        Section,
    },
    props: {
        documentId: {
            type: Number,
            required: true,
        },
        eventId: {
            type: Number,
            default: null,
        },
        initialView: {
            type: String,
            default: 'edit',
        },
        canEdit: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            viewOptions: [
                {
                    text: 'Edit',
                    value: 'edit',
                    icon: 'fa fa-cog',
                },
                {
                    text: 'Complete',
                    value: 'view',
                    icon: 'fa fa-pencil',
                },
                {
                    text: 'Preview',
                    value: 'preview',
                    icon: 'fa fa-eye',
                },
            ],
        };
    },
    computed: {
        ...sync('document', [
            'document',
            'document@title',
        ]),
        sortedSections: {
            get() {
                return this.document.sections;
            },
            set(sections) {
                dispatch('document/updateSectionsOrder', sections.map(section => section.id));
            },
        },
        ...sync('document', [
            'dragging',
            'view',
        ]),
    },
    created() {
        this.$store.registerModule('document', store);
    },
    async mounted() {
        await dispatch('document/setDocumentId', this.documentId);
        await dispatch('document/setEventId', this.eventId);
        await dispatch('document/setView', this.initialView);
        await dispatch('document/loadDocument');
    },
    methods: {
        saveDocument: debounce(250, () => {
            dispatch('document/saveDocument');
        }),
    },
};
</script>
